import PropTypes from 'prop-types';
import React from 'react';
import {withTranslation} from 'react-i18next';
import {t} from 'i18next';
import BaseDialogContainer from '../../baseContainers/BaseDialogContainer';
import {ActionButton} from '../../components/ActionButton';
import DivContainer from '../../components/DivContainer';
import SettingModel from '../../model/SettingModel';
import Constants from '../../utils/constants';
import {withRouter} from 'react-router-dom/cjs/react-router-dom.min';
import InputFileUploadComponent from '../../components/inputs/InputFileUploadComponent';
import MobileUserService from '../../services/MobileUserService';
import { Chip, Column, DataTable, ProgressBar } from 'primereact';
import ImportLogList from './UserImportList';
import MobileUserImportService from '../../services/MobileUserImportService';
import ReminderService from '../../services/ReminderService';

class ImportUsersDialog extends BaseDialogContainer {
    constructor(props) {
        super(props, new MobileUserService());
        this.state = {
            list:[],
            element: {
                files: []
            },
            expandedRows: [],
            criteria: this.getCleanSearchCriteria(),
            progress: 0,
            viewMode: this.props.viewMode,
            booleanOptions: Constants.BOOLEAN_OPTIONS,
        };
        this.importService = new MobileUserImportService();
        this.reminderService = new ReminderService();
        this.uploadError = this.uploadError.bind(this);
    }

    updateSearchCriteria(criteria) {
        return {
            firstResult: criteria.firstResult,
            maxResults: criteria.maxResults,
            roles: criteria.roles,
            sortField: criteria.sortField,
            sortAsc: criteria.sortAsc,
        };
    }

    getCleanSearchCriteria() {
        return {
            email: '',
            firstName: '',
            lastName: '',
            role: undefined,
            id: null,
            firstResult: 0,
            roles: [],
            maxResults: 10,
            sortField: 'id',
            sortAsc: true,
        };
    }



    translate(key) {
        const {t} = this.props;
        return t(key);
    }
    prepareFooter() {
        const {t} = this.props;
        return (
            <div className='footer-dialog-button-container'>
                <div className='left-footer-dialog-button-container'></div>
                <ActionButton label={t('details.cancel')} variant={'button cancel-button gray'} handleClick={this.props.onHide} />
                <ActionButton label={t('details.saveChanges')} variant='button save-button blue' handleClick={this.handleFormSubmit} />
            </div>
        );
    }
    afterUpdateSuccess(response) {
        const {backUrl} = this.props;
        this.blockUi();
        this.persistMessage('success', '', this.getUpdateSucces(response));
        // window.location.href = AppPrefixUtils.locationHrefUrl(backUrl);
        this.props.history.push(backUrl);
        this.props.afterSave();
    }
    getUpdateSucces() {
        const {t} = this.props;
        return t('setting.updateSettingSuccess');
    }

    renderHeader() {
        const {t} = this.props;
        return (
            <DivContainer colClass='col-12'>
                <DivContainer colClass='col-12'>
                    <label>{'Import użytkowników'}</label>
                </DivContainer>
            </DivContainer>
        );
    }
    updateElement(data) {
       
    }
    getContainerListName() {
        return 'setting-list-container';
    }

     importHeaderTemplate = (options) => {
        const { className, chooseButton, uploadButton, cancelButton } = options;
        return (
            <div className={className} style={{ backgroundColor: 'transparent', display: 'flex', alignItems: 'center' }}>
                {chooseButton}
                {uploadButton}
                {cancelButton}
                <div className="flex align-items-center gap-3 ml-auto">
                </div>
            </div>
        );
    };

    totalNotImported(e) {
        return e.users.filter((u) => u.status !== 'IMPORTED').length;
    }
    totalImported(e) {
        return e.users.filter((u) => u.status === 'IMPORTED').length;
    }
    total(e) {
        return e.users.length;
    }

    onKeyDown(e) {
    }
    rowExpansionTemplate(data){
        return (
            <DivContainer colClass='row'>
                <DataTable value={data.users} header={'Projekty'} emptyMessage={t('list.empty')}>
                    <Column field="fullName" header={t('project.name')} sortable></Column>
                    <Column field="status" header={t('project.dateStart')} sortable body={
                        (value) => {
                            const color = value.status === 'IMPORTED' ? 'green' : 'red';
                            const label = value.status === 'IMPORTED' ? 'Zaimportowano' : 'Niezaimportowano';
                            return (
                                <Chip style={{ color: color }} label={label} />
                            );
                        }}>
                    </Column>
                </DataTable>
            </DivContainer>
        );
    }

    updateListElements(list) {
        return list;
    }

    getList() {
        const { criteria } = this.state;
        const activeElement = document.activeElement;
        this.setState(
            {
                loading: true,
            },
            () => {
                this.importService
                    .getUserImportList(criteria)
                    .then((data) => {
                        if (this._isMounted) {
                            this.setState(
                                {
                                    list: this.updateListElements(data.content),
                                    loading: false,
                                    size: data.totalElements,
                                },
                                () => {
                                    // this.onAfterGetList(data);
                                    this.setTimeout(() => activeElement?.focus(), 50);
                                }
                            );
                        }
                    })
                    .catch((err) => {
                        if (this._isMounted) {
                            this.setState(
                                {
                                    list: [],
                                    loading: false,
                                    size: 0,
                                },
                                () => {
                                    // this.afterGetListError();
                                }
                            );
                        }
                    });
            }
        );
    }

    initBeforeSetElement() {
        this.getList();
    }

    uploadError(){
        this.props.showErrorMessage('Wystąpił błąd podczas importowania');
        this.getList();
    }

    renderDatatable() {
    }

    renderDetails() {
        const { t } = this.props;
        return (
            <React.Fragment>
                <DivContainer colClass='row'>
                <div className="file-format-info col-xl-12" style={{ marginBottom: '20px' }}>
                        <p><strong>Proszę użyć pliku w formacie CSV z kolumnami: imię, nazwisko, email.</strong></p>
                    </div>
                    <InputFileUploadComponent
                        messages={this.messages}
                        id='files'
                        name='files'
                        fileList={this.state.element?.files}
                        value={this.state.element?.files}
                        restApiUrl={`${this.service.getPath()}/upload`}
                        maxFileSize={50000000}
                        onChange={(e)=>this.handleChange}
                        itemLabel='fileName'
                        itemName='uuid'
                        accept='.csv'
                        colClass='col-xl-12'
                        style={{ width: '100%' }}
                        handleError={this.uploadError}
                        token={this.authService.getToken()}
                        validator={this.validator}
                        restrictExt={false}
                        validators='not_required'
                        viewMode={'NEW'}
                        multiple={false}
                        chooseLabel={'Wybierz plik'}
                        uploadLabel={'Zaimportuj'}
                        cancelLabel={'Anuluj'}
                        onAfterStateChange={() =>{
                            this.setState({
                                validationResult: undefined,
                            })
                            }
                        }
                        disableDialog={true}
                        headerTemplate={this.importHeaderTemplate}
                        autoDisabled={true}
                        onProgress={(e)=>{
                                const progress = Math.round((100 * e.originalEvent.loaded) / e.originalEvent.total);
                                this.setState({progress});
                        }}
                        handleUpload={(e)=>{
                            this.setState({
                                summary: JSON.parse(e.xhr.response)
                            },()=>{
                                this.getList();
                            });
                        }}
                        onUpload={(e) => {
                            this.props.showSuccessMessage('Pomyślnie ukończono import użytkowników');
                            this.setState({
                                summary: JSON.parse(e.xhr.response),
                            }, () => {
                                this.getList();
                            });
                        }}
                    />
                    {
                        <ImportLogList
                            validator={this.validator}
                            rowExpansionTemplate
                            hideFilters
                            name={this.state.name}
                            criteria={this.state.criteria}
                        />
                    }
                </DivContainer>
            </React.Fragment>
        );
    }
}

ImportUsersDialog.defaultProps = {
    currentUser: undefined,
    visible: false,
    stationId: undefined,
    style: {width: '1200px'},
};

ImportUsersDialog.propTypes = {
    cancelUrl: PropTypes.string,
    currentUser: PropTypes.object,
    editUrl: PropTypes.string,
    viewMode: PropTypes.string,
    visible: PropTypes.bool,
    onHide: PropTypes.func,
    afterSave: PropTypes.func,
    elementId: PropTypes.number,
    stationId: PropTypes.number,
};

export default withRouter(withTranslation()(ImportUsersDialog));
